/**
 * Shared styles for HTML content rendering
 * Used across lesson content blocks to ensure consistent styling
 * for headings, lists, code blocks, tables, etc.
 */
export const htmlContentStyles = {
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    fontWeight: 700,
    marginTop: 3,
    marginBottom: 2,
    lineHeight: 1.3,
  },
  '& h1': { fontSize: '2rem' },
  '& h2': { fontSize: '1.75rem' },
  '& h3': { fontSize: '1.5rem' },
  '& h4': { fontSize: '1.25rem' },
  '& h5': { fontSize: '1.125rem' },
  '& h6': { fontSize: '1rem' },
  '& p': {
    marginBottom: 1.5,
    lineHeight: 1.7,
  },
  '& ul, & ol': {
    marginBottom: 2,
    paddingLeft: 3,
  },
  '& li': {
    marginBottom: 0.75,
    lineHeight: 1.6,
  },
  '& code': {
    backgroundColor: 'action.hover',
    padding: '2px 6px',
    borderRadius: '4px',
    fontSize: '0.875em',
    fontFamily: 'monospace',
  },
  '& pre': {
    backgroundColor: 'action.hover',
    padding: 2,
    borderRadius: 1,
    overflow: 'auto',
    marginBottom: 2,
  },
  '& pre code': {
    backgroundColor: 'transparent',
    padding: 0,
  },
  '& a': {
    color: 'primary.main',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  '& blockquote': {
    borderLeft: '4px solid',
    borderColor: 'divider',
    paddingLeft: 2,
    marginLeft: 0,
    marginBottom: 2,
    fontStyle: 'italic',
    color: 'text.secondary',
  },
  '& img': {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: 1,
    marginBottom: 2,
  },
  '& table': {
    borderCollapse: 'collapse',
    width: '100%',
    marginBottom: 2,
  },
  '& th, & td': {
    border: '1px solid',
    borderColor: 'divider',
    padding: 1,
    textAlign: 'left',
  },
  '& th': {
    backgroundColor: 'action.hover',
    fontWeight: 600,
  },
};
